import React, { useState, useEffect } from "react";
import DeviceFlow from "./DeviceFlow";
import { MapContainer, TileLayer, Marker, Tooltip } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import icon from "../../../../assets/icons/maps-and-flags.png";
import DeviceChart from "../../Admin/DeviceDetail/DeviceDetail/DeviceChart";
import LevelDeviceChart from "../../Admin/DeviceDetail/DeviceDetail/LevelDeviceChart";
import AssignCustomer from "../DealerPanel/AssignCustomer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Devicelevel from "../../Admin/DeviceDetail/DeviceDetail/DeviceLevel";
import parseNumber from "../../../../utils/parseCalculate";
import axios from "../../../../utils/axios";
import { useLiveDevice } from "../../../../hooks/useLiveDeviceData";
import DoSensorReadings from "../../../utilities/DoSensorReadings";
import DoSensorHistory from "../../../utilities/DeviceDetail/DoSensorHistory";

const DealerDeviceDetail = (props) => {
  const { id: dealerDeviceDetailId } = useParams();
  const [deviceDetail, setDeviceDetail] = useState({});
  const [assignDealer, setAssignDealer] = useState(false);
  const [assignCustomer, setAssignCustomer] = useState(false);
  const [deviceFlowDetail, setDeviceFlowDetail] = useState({});
  const { data: liveData, units: liveUnits } = useLiveDevice(
    dealerDeviceDetailId
  );

  const getList = async () => {
    await axios
      .post("view/devices/dealer", {
        deviceId: +dealerDeviceDetailId,
      })
      .then((response) => {
        const filteredData = response?.data?.find(
          (orignalData) => orignalData?.id === +dealerDeviceDetailId
        );
        setDeviceDetail(filteredData);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getList();
  }, [dealerDeviceDetailId, assignDealer, assignCustomer]);

  useEffect(() => {
    if (!liveData) return;
    setDeviceFlowDetail({
      flow: parseNumber(liveData.flowrate || liveData.level),
      unit: liveUnits.flow_unit || liveUnits.level_unit,
      totalFlow: parseNumber(liveData.totalizer),
      totalUnit: liveUnits.total_unit,
      networkStatus: liveData.network_active,
      battery: liveData.battery,
      deviceType: deviceDetail?.device_type,
    });
  }, [liveData, liveUnits, deviceDetail]);

  const handleUnassignCustomer = () => {
    axios
      .post("unassign/customer", {
        deviceId: +dealerDeviceDetailId,
      })
      .then(() => {
        Swal.fire({
          title: "Success",
          text: "User successfully unassigned",
          icon: "success",
        });

        getList();
      })
      .catch((error) => {
        Swal.fire({
          title: "Try Again",
          text: "Try again",
          icon: "error",
        });
      });
  };

  let assignedCustomer = "";

  if (deviceDetail.customer_name !== null) {
    assignedCustomer = (
      <>
        {deviceDetail.customer_name}{" "}
        <button onClick={handleUnassignCustomer} className="text-danger fs-6">
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </>
    );
  } else {
    assignedCustomer = (
      <button
        onClick={() => {
          setAssignCustomer(true);
        }}
        className="empty-text"
      >
        Assign Customer
      </button>
    );
  }

  return (
    <div className="admin-device-detail">
      {/* <Loading /> */}
      <div className="device-detail-header">
        <div className="user-inner-detail">
          <div>
            <p className="device-name"> {deviceDetail.deviceId} </p>
            <p className="alias-name">
              alias name:{" "}
              <span className="text-primary"> {deviceDetail.alias_name} </span>
            </p>
            {deviceDetail.imei && (
              <p className="alias-name">
                IMEI:{" "}
                <span className="text-primary"> {deviceDetail.imei} </span>
              </p>
            )}
            {deviceDetail.sim_number && (
              <p className="alias-name">
                SIM:{" "}
                <span className="text-primary">
                  {" "}
                  {deviceDetail.sim_number}{" "}
                </span>
              </p>
            )}
          </div>

          <div>
            <p className="assignee-detail">Assigned Customer</p>
            <p className="assignee-info text-primary">{assignedCustomer}</p>
          </div>

          <div>
            <p className="assignee-detail">Assigned Dealer</p>
            <p className="assignee-info text-primary">
              {deviceDetail.dealer_name}
            </p>
          </div>

          <div>
            <p className="assignee-detail">Subscription End</p>
            <p className="assignee-info text-primary">
              {new Date(deviceDetail.subscription_end).toLocaleDateString(
                "en-US",
                {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                }
              )}
            </p>
          </div>
        </div>

        {deviceDetail.device_type === "do_sensor" ? <DoSensorReadings data={liveData} id={+dealerDeviceDetailId} reportlink="/dealer-report" /> :
          <Devicelevel id={+dealerDeviceDetailId} deviceDetail={deviceFlowDetail} reportlink="/dealer-report" />}
      </div>

      <div className="user-detail">
        <div className="chart-area">
          <h5 className="title">{deviceDetail.device_type === "do_sensor" ? "Dissolved Oxygen Chart" : "Flow Chart"}</h5>
          {deviceDetail.device_type === "flow" ? (
            <DeviceChart id={+dealerDeviceDetailId} isDealer={true} />
          ) : deviceDetail.device_type === "gas" ? (
            <p className="text-secondary mt-5 ms-2">
              Historical gas chart is not available yet. Live readings update
              over the websocket.
            </p>
          ) : deviceDetail.device_type === "do_sensor" ? (
            <DoSensorHistory deviceId={+dealerDeviceDetailId} endpoint="dealer/view/do_sensor/history" showControls={false} />
          ) : (
            <LevelDeviceChart id={+dealerDeviceDetailId} isDealer={true} />
          )}
        </div>
        <div className="map-area">
          <h5 className="title">Device Map</h5>

          <div className="map-box">
            {deviceDetail.latitude && deviceDetail.longitude ? (
              <MapContainer
                center={[deviceDetail.latitude, deviceDetail.longitude]}
                zoom={8}
                scrollWheelZoom={false}
                style={{ height: "100vh", width: "100%" }}
              >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <Marker
                  position={[deviceDetail.latitude, deviceDetail.longitude]}
                  icon={L.icon({
                    iconUrl: icon,
                    iconSize: [40, 40],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                  })}
                >
                  <Tooltip>{deviceDetail.location}</Tooltip>
                </Marker>
              </MapContainer>
            ) : (
              <p className="text-danger mt-5 ms-2 fw-bold fs-5">
                No data for location
              </p>
            )}
          </div>
        </div>
      </div>

      <AssignCustomer
        show={assignCustomer}
        onHide={() => {
          setAssignCustomer(false);
        }}
        id={deviceDetail.id}
      />
    </div>
  );
};

export default DealerDeviceDetail;
